import * as Sentry from '@sentry/sveltekit';
Sentry.init({
	dsn: 'https://daa7b557cd99555c0162f54c57d4fd8d@o4509252041834496.ingest.us.sentry.io/4509252076044288',
	// Adds request headers and IP for users, for more info visit:
	// https://docs.sentry.io/platforms/javascript/guides/sveltekit/configuration/options/#sendDefaultPii
	sendDefaultPii: true,
	// We recommend adjusting this value in production, or using tracesSampler
	// for finer control
	tracesSampleRate: 1.0,
	// Optional: Initialize Session Replay:
	integrations: [Sentry.replayIntegration()],
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0
});
const myErrorHandler = ({ error, event }) => {
	console.error('An error occurred on the client side:', error, event);
};
export const handleError = Sentry.handleErrorWithSentry(myErrorHandler);
